import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a3eac17"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "index-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding":"16px 0"} }, [
  /*#__PURE__*/_createTextVNode(" 用于批量替换代理线路的连接信息 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 1.导入用于替换的线路信息 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 2.拖动连接信息与待替换线路对应 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 3.点击确定完成替换 ")
], -1))
const _hoisted_3 = { class: "form-field" }
const _hoisted_4 = { class: "tabs" }
const _hoisted_5 = { class: "tab" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-title" }, "待替换线路", -1))
const _hoisted_7 = { class: "ant-table ant-table-small ant-table-bordered" }
const _hoisted_8 = { class: "ant-table-container" }
const _hoisted_9 = { class: "ant-table-content" }
const _hoisted_10 = { style: {"table-layout":"auto"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "ant-table-thead" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "ant-table-cell",
      colstart: "0",
      colend: "0",
      style: {"text-align":"center"}
    }, " 序号 "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "ant-table-cell",
      colstart: "1",
      colend: "1"
    }, " 线路名 "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "ant-table-cell",
      colstart: "2",
      colend: "2"
    }, " 出口IP/归属地 ")
  ])
], -1))
const _hoisted_13 = { class: "ant-table-tbody" }
const _hoisted_14 = {
  class: "ant-table-cell",
  style: {"text-align":"center"}
}
const _hoisted_15 = { class: "ant-table-cell" }
const _hoisted_16 = { class: "ant-table-cell" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { style: {"color":"#1da57a"} }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " | ", -1))
const _hoisted_20 = { class: "tab sortable" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-title" }, "拖动可以调整顺序", -1))
const _hoisted_22 = { class: "ant-table ant-table-small ant-table-bordered" }
const _hoisted_23 = { class: "ant-table-container" }
const _hoisted_24 = { class: "ant-table-content" }
const _hoisted_25 = { style: {"table-layout":"auto"} }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "ant-table-thead" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "ant-table-cell",
      colstart: "0",
      colend: "0",
      style: {"text-align":"center"}
    }, " 序号 "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "ant-table-cell",
      colstart: "1",
      colend: "1"
    }, " 线路名 "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "ant-table-cell",
      colstart: "2",
      colend: "2"
    }, " 出口IP/归属地 ")
  ])
], -1))
const _hoisted_28 = { class: "ant-table-row ant-table-row-level-0" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "ant-table-cell",
  style: {"text-align":"center"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "drag-handle" }, "☰")
], -1))
const _hoisted_30 = { class: "ant-table-cell" }
const _hoisted_31 = { style: {"color":"#1da57a"} }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " | ", -1))
const _hoisted_33 = { class: "ant-table-cell" }
const _hoisted_34 = { class: "ant-table-cell" }
const _hoisted_35 = { class: "form-btn-group" }

import {
  computed,
  inject,
  nextTick,
  onMounted,
  ref,
  shallowRef,
  watch,
} from 'vue';
import ScBtn from '@/components/common/widget/ScBtn.vue';
import { windows } from '@/components/common/window/Windows';
import ImportProxy from '@/views/management/proxy/import/ImportProxy.vue';
import ScPage from '@/components/common/page/ScPage.vue';
import { WindowTool } from '@/components/common/window/WindowInterface';
import { Modal } from 'ant-design-vue';
import { request } from '@/util/request';
import _ from 'lodash';
import draggable from 'vuedraggable'


export default /*#__PURE__*/_defineComponent({
  __name: 'ReplaceProxy',
  props: {
    proxies: {}
  },
  setup(__props: any) {

const props = __props;

const renderProxies = computed(() => {
  const res = [...props.proxies];
  for (let i = res.length; i < replaceData.value.length; i++) {
    res.push({});
  }
  return res;
});

const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    align: 'center',
  },
  {
    title: '线路名',
    dataIndex: 'name',
  },
  {
    title: '出口IP/归属地',
    dataIndex: 'address',
  },
];

const dragColumns = [
  {
    title: '拖动',
    dataIndex: 'drag',
    width: 60,
  },
  {
    title: 'ss',
    dataIndex: 'tmpId',
  },
  {
    title: '连接信息',
    dataIndex: 'info',
  },
  {
    title: '出口IP/归属地',
    dataIndex: 'address',
  },
  {
    title: '操作',
    dataIndex: 'operation',
  },
];

let replaceTmpId = 0;
const replaceData = ref<any[]>([]);
replaceData.value = [];

async function importProxy() {
  const id = windows.open({
    content: {
      type: 'component',
      component: shallowRef(ImportProxy),
      props: {
        onSubmit: (items: any[]) => {
          replaceData.value.push(
            ...items.map((i) => ({ ...i, tmpId: replaceTmpId++ }))
          );
          return true;
        },
        selectTagGroup: false,
      },
    },
    title: '导入代理线路',
  });
  await windows.getCloseData(id);
}

const windowTool = inject<WindowTool | false>(WindowTool, false);

async function onSubmit() {
  Modal.confirm({
    title: '确定要进行替换吗？',
    onOk: async () => {
      const updateLength = Math.min(
        props.proxies.length,
        replaceData.value.length
      );
      let res = false;
      if (updateLength > 0) {
        const data = [];
        for (let i = 0; i < updateLength; i++) {
          data.push({
            id: props.proxies[i].id,
            data: _.omit(replaceData.value[i], 'tags'),
          });
        }
        res = await request('management/proxy/batchUpdate', { data });
      }
      if (windowTool) {
        windowTool.close(res);
      }
    },
  });
}

function onCancel() {
  if (windowTool) {
    windowTool.close(false);
  }
}

const drag = ref(false)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ScPage, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(ScBtn, {
            size: "small",
            type: "primary",
            text: "点击导入线路",
            handler: importProxy
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("table", _hoisted_10, [
                    _hoisted_11,
                    _hoisted_12,
                    _createElementVNode("tbody", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(renderProxies.value, (record, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          class: "ant-table-row ant-table-row-level-0",
                          key: index
                        }, [
                          _createElementVNode("td", _hoisted_14, _toDisplayString(index + 1), 1),
                          _createElementVNode("td", _hoisted_15, _toDisplayString(record.name), 1),
                          _createElementVNode("td", _hoisted_16, [
                            (record.id)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  _createElementVNode("span", _hoisted_18, _toDisplayString(record.username), 1),
                                  _hoisted_19,
                                  _createElementVNode("span", null, _toDisplayString(record.type) + "://" + _toDisplayString(record.host) + ":" + _toDisplayString(record.port), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("table", _hoisted_25, [
                    _hoisted_26,
                    _hoisted_27,
                    _createVNode(_unref(draggable), {
                      class: "ant-table-tbody",
                      tag: "tbody",
                      modelValue: replaceData.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((replaceData).value = $event)),
                      "item-key": "id"
                    }, {
                      item: _withCtx(({element: record}) => [
                        _createElementVNode("tr", _hoisted_28, [
                          _hoisted_29,
                          _createElementVNode("td", _hoisted_30, [
                            _createElementVNode("span", _hoisted_31, _toDisplayString(record.username), 1),
                            _hoisted_32,
                            _createElementVNode("span", null, _toDisplayString(record.type) + "://" + _toDisplayString(record.host) + ":" + _toDisplayString(record.port), 1)
                          ]),
                          _createElementVNode("td", _hoisted_33, _toDisplayString(record.outIp || ' - ') + " | " + _toDisplayString(record.area || ' - '), 1),
                          _createElementVNode("td", _hoisted_34, [
                            _createVNode(ScBtn, {
                              size: "small",
                              type: "link",
                              text: "删除",
                              handler: () => replaceData.value.splice(_ctx.index, 1)
                            }, null, 8, ["handler"])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createVNode(ScBtn, {
          handler: onSubmit,
          text: "确定",
          type: "primary"
        }),
        _createVNode(ScBtn, {
          handler: onCancel,
          style: {"margin-left":"10px"},
          text: "取消"
        })
      ])
    ]),
    _: 1
  }))
}
}

})